export const maskCpfCnpj = (v: string) => {
  // Remove apenas caracteres especiais, mantém letras e números
  v = v.replace(/[^\w]/g, '').toUpperCase().slice(0, 14);

  const hasLetter = /[A-Z]/.test(v);

  if (v.length <= 11 && !hasLetter) {
    // Máscara CPF: NNN.NNN.NNN-NN
    v = v.replace(/(\w{3})(\w)/, '$1.$2');
    v = v.replace(/(\w{3})(\w)/, '$1.$2');
    v = v.replace(/(\w{3})(\w{1,2})$/, '$1-$2');
  } else {
    // Máscara CNPJ: SS.SSS.SSS/SSSS-NN (aceita alfanumérico)
    v = v.replace(/^(\w{2})(\w)/, '$1.$2');
    v = v.replace(/^(\w{2})\.(\w{3})(\w)/, '$1.$2.$3');
    v = v.replace(/\.(\w{3})(\w)/, '.$1/$2');
    v = v.replace(/(\w{4})(\w)/, '$1-$2');
  }

  return v;
};
